import { Controller } from "@hotwired/stimulus"

// On form submit: disable button, replace text with spinner.
// On turbo:submit-end: re-enable.
// Prevents double-submit.

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this._submitStart = this._handleSubmitStart.bind(this)
    this._submitEnd = this._handleSubmitEnd.bind(this)
    this.element.addEventListener("turbo:submit-start", this._submitStart)
    this.element.addEventListener("turbo:submit-end", this._submitEnd)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-start", this._submitStart)
    this.element.removeEventListener("turbo:submit-end", this._submitEnd)
    this._restore()
  }

  // Called from data-action="loading-button#submit" OR turbo:submit-start
  submit() {
    this._showSpinner()
  }

  _handleSubmitStart() {
    this._showSpinner()
  }

  _handleSubmitEnd() {
    this._restore()
  }

  _showSpinner() {
    if (!this.hasButtonTarget || this._savedNodes !== undefined) return

    const btn = this.buttonTarget
    this._savedNodes = Array.from(btn.childNodes).map(n => n.cloneNode(true))
    this._originalDisabled = btn.disabled

    btn.disabled = true
    // Build spinner with safe DOM methods
    btn.textContent = ""
    const spinner = document.createElement("span")
    spinner.className = "loading loading-spinner loading-sm"
    btn.appendChild(spinner)
    btn.appendChild(document.createTextNode(" Processing..."))
  }

  _restore() {
    if (!this.hasButtonTarget || this._savedNodes === undefined) return

    const btn = this.buttonTarget
    btn.disabled = this._originalDisabled
    btn.textContent = ""
    this._savedNodes.forEach(node => btn.appendChild(node))
    this._savedNodes = undefined
  }
}
